import { ADDTOCART, ADD, LESS } from "./actionType";

export function addCart(items) {
  return {
    type: ADDTOCART,
    payload: items,
  };
}
export function add(item) {
  return {
    type: ADD,
    payload: item,
  };
}
export function less(item) {
  return {
    type: LESS,
    payload: item,
  };
}
